module.exports = __webpack_public_path__ + "img/4.c8b3a799.png";